import React from "react";
import { Sparkles, Zap, Shield, Layers } from "lucide-react";
import "./AnnouncementBar.css";

export default function AnnouncementBar() {
  const items = [
    {
      icon: <Sparkles size={14} className="ticker-icon-gold" />,
      text: "Special Promo: Exciting offers on Yearly Plans! Get up to 30% discount today.",
      badge: "OFFER"
    },
    {
      icon: <Zap size={14} className="ticker-icon-blue" />,
      text: "Easy Trade Management: Copy trades from TradingView to MT5 in milliseconds.",
      badge: "FAST"
    },
    {
      icon: <Shield size={14} className="ticker-icon-green" />,
      text: "High Security: 100% secure automated webhook forwarding with activity logging.",
      badge: "SECURE"
    },
    {
      icon: <Layers size={14} className="ticker-icon-purple" />,
      text: "Multi-Terminal Support: Connect and copy signals to multiple MT5 accounts simultaneously.",
      badge: "MULTI-ACC"
    }
  ];

  // Repeat the items to make the marquee loop seamless
  const duplicatedItems = [...items, ...items, ...items];

  return (
    <div className="announcement-bar">
      <div className="announcement-ticker-container">
        <div className="announcement-ticker">
          {duplicatedItems.map((item, index) => (
            <div className="ticker-item" key={index}>
              <span className={`ticker-badge badge-${item.badge.toLowerCase()}`}>{item.badge}</span>
              <span className="ticker-icon-wrapper">{item.icon}</span>
              <span className="ticker-text">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
